var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"users.label","bread-crumb-data":_vm.breadCrumbData}},[_c('b-card',[_c('users-table',{attrs:{"company-id":_vm.company.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }